type Props = {
  /** Points the chevron left (collapse) when false, right (expand) when true. */
  flipped?: boolean
  size?: number
  className?: string
}

/**
 * Panel-with-chevron glyph used to pin/collapse side panels (steps wizard,
 * side navigation). Strokes with `currentColor` so the parent sets the tint.
 */
const SidebarToggleIcon = ({
  flipped = false,
  size = 24,
  className,
}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={`transition-transform duration-300 ease-out motion-reduce:transition-none ${
      flipped ? "rotate-180" : "rotate-0"
    } ${className ?? ""}`}
  >
    <path
      d="M8.25 4.5V19.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.25 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 9.5L16.5 12L14 14.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SidebarToggleIcon
